'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiRss = function TiRss(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 26.7c-1.8 0-3.3 1.5-3.3 3.3 0 1.8 1.5 3.3 3.3 3.3 1.8 0 3.3-1.5 3.3-3.3 0-1.8-1.5-3.3-3.3-3.3z m0-20c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3c9.2 0 16.7 7.5 16.7 16.7 0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3c0-12.9-10.4-23.3-23.3-23.3z m0 10c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3c3.7 0 6.7 3 6.7 6.7 0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3c0-7.4-5.9-13.3-13.3-13.3z' })
        )
    );
};

exports.default = TiRss;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/rss.js
// module id = 2162
// module chunks = 0